import styled, { css } from 'styled-components';

export interface InputElementProps {
  $hasError?: boolean;
}

export const Wrapper = styled.label``;

export const Input = styled.input<InputElementProps>`
  display: block;
  width: 100%;
  padding: 0.5rem 0.75rem;
  overflow: hidden;
  color: ${({ theme }) => theme.tokens.colors.text[100]};
  font-size: 0.8rem;
  font-weight: 500;
  line-height: 1rem;
  border-radius: 6px;
  border: 1px solid ${({ theme }) => theme.tokens.colors.neutral[300]};
  background-color: ${({ theme }) => theme.tokens.colors.neutral[100]};

  &::placeholder {
    color: ${({ theme }) => theme.tokens.colors.text[400]};
  }

  &:-webkit-autofill {
    color: #526173 !important;
    box-shadow: inset 0 0 0 2.5rem #f7ebf3 !important;
  }

  &:disabled {
    background-color: #eeeff1;
    color: #c8ccd1;
  }

  &:hover {
    border-color: #bdbdbd;
  }

  &:active,
  &:focus {
    border-color: #526173;

    ${({ $hasError }) =>
      $hasError &&
      css`
        border-color: ${({ theme }) => theme.tokens.colors.system[100]};
      `}
  }

  ${({ $hasError }) =>
    $hasError &&
    css`
      border-color: ${({ theme }) => theme.tokens.colors.system[100]};
    `}
`;
